"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-50cf98bc"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { class: "TUIChat-header" };
var _hoisted_2 = { class: "setting" };
var _hoisted_3 = { class: "TUIChat-main" };
var _hoisted_4 = ["id"];
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_1.createElementVNode("i", { class: "icon icon-bottom-double" }, null, -1); });
var _hoisted_6 = { class: "to-bottom-tip-cont" };
var _hoisted_7 = {
    key: 0,
    class: "dialog dialog-conversation"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = { class: "name" };
var _hoisted_10 = ["src"];
var _hoisted_11 = {
    key: 0,
    class: "name"
};
var _hoisted_12 = { class: "dialog dialog-conversation" };
var _hoisted_13 = {
    class: "func",
    id: "func"
};
var _hoisted_14 = { class: "func-main" };
var _hoisted_15 = { class: "mask-main" };
var _hoisted_16 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_1.createElementVNode("i", null, null, -1); });
var _hoisted_17 = {
    key: 1,
    class: "TUIChat"
};
var _hoisted_18 = { class: "TUIChat-header" };
var _hoisted_19 = ["src"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c;
    var _component_TypingHeader = vue_1.resolveComponent("TypingHeader");
    var _component_Replies = vue_1.resolveComponent("Replies");
    var _component_MessageTimestamp = vue_1.resolveComponent("MessageTimestamp");
    var _component_MessageItem = vue_1.resolveComponent("MessageItem");
    var _component_ReadReceiptDialog = vue_1.resolveComponent("ReadReceiptDialog");
    var _component_imagePreviewer = vue_1.resolveComponent("imagePreviewer");
    var _component_MessageInput = vue_1.resolveComponent("MessageInput");
    var _component_MessageSystem = vue_1.resolveComponent("MessageSystem");
    return (_ctx.conversationType === 'chat')
        ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
            key: 0,
            class: vue_1.normalizeClass(["TUIChat", [_ctx.env.isH5 ? 'TUIChat-H5' : '']])
        }, [
            vue_1.createElementVNode("header", _hoisted_1, [
                (_ctx.env.isH5)
                    ? (vue_1.openBlock(), vue_1.createElementBlock("i", {
                        key: 0,
                        class: "icon icon-back",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                return (_ctx.back && _ctx.back.apply(_ctx, args));
                            })
                    }))
                    : vue_1.createCommentVNode("", true),
                vue_1.createVNode(_component_TypingHeader, {
                    needTyping: _ctx.needTyping,
                    conversation: _ctx.conversation,
                    messageList: _ctx.messageList,
                    selfSignature: _ctx.selfSignature,
                    ref: "typingRef"
                }, null, 8, ["needTyping", "conversation", "messageList", "selfSignature"]),
                vue_1.createElementVNode("aside", _hoisted_2, [
                    vue_1.createVNode(_component_Replies, {
                        message: _ctx.currentMessage,
                        conversation: _ctx.conversation,
                        show: _ctx.repliesDialogStatus,
                        isH5: _ctx.env.isH5,
                        messageList: _ctx.messageList,
                        onCloseDialog: _ctx.closeDialog,
                        ref: "repliesDialog"
                    }, null, 8, ["message", "conversation", "show", "isH5", "messageList", "onCloseDialog"])
                ])
            ]),
            vue_1.createElementVNode("div", _hoisted_3, [
                vue_1.createElementVNode("ul", {
                    class: "TUI-message-list",
                    onClick: _cache[3] || (_cache[3] = function ($event) { return (_ctx.dialogID = ''); }),
                    ref: "messageEle",
                    id: "messageEle"
                }, [
                    (!_ctx.isCompleted)
                        ? (vue_1.openBlock(), vue_1.createElementBlock("p", {
                            key: 0,
                            class: "message-more",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    return (_ctx.getHistoryMessageList && _ctx.getHistoryMessageList.apply(_ctx, args));
                                })
                        }, vue_1.toDisplayString(_ctx.$t("TUIChat.查看更多")), 1))
                        : vue_1.createCommentVNode("", true),
                    (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.messages, function (item, index) {
                        var _a;
                        return (vue_1.openBlock(), vue_1.createElementBlock("li", {
                            key: index,
                            id: item === null || item === void 0 ? void 0 : item.ID,
                            ref_for: true,
                            ref: "messageAimID"
                        }, [
                            vue_1.createVNode(_component_MessageTimestamp, {
                                currTime: item === null || item === void 0 ? void 0 : item.time,
                                prevTime: index > 0 ? (_a = _ctx.messages[index - 1]) === null || _a === void 0 ? void 0 : _a.time : 0
                            }, null, 8, ["currTime", "prevTime"]),
                            vue_1.createVNode(_component_MessageItem, {
                                message: item,
                                env: _ctx.env,
                                types: _ctx.types,
                                displayGroupMessageReadReceipt: _ctx.needGroupReceipt,
                                displayEmojiReactions: _ctx.isNeedEmojiReact,
                                messageList: _ctx.messages,
                                onHandleEditor: _ctx.handleEditor,
                                onShowDialog: _ctx.showDialog,
                                onUploading: _ctx.handleUploadingImageOrVideo,
                                onJumpID: _ctx.jumpID,
                                onResendMessage: _ctx.resendMessage
                            }, null, 8, ["message", "env", "types", "displayGroupMessageReadReceipt", "displayEmojiReactions", "messageList", "onHandleEditor", "onShowDialog", "onUploading", "onJumpID", "onResendMessage"])
                        ], 8, _hoisted_4));
                    }), 128)),
                    (_ctx.needToBottom)
                        ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
                            key: 1,
                            class: "to-bottom-tip",
                            onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.scrollToTarget('bottom')); })
                        }, [
                            _hoisted_5,
                            vue_1.createElementVNode("div", _hoisted_6, [
                                vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.toBottomTipCont), 1)
                            ])
                        ]))
                        : vue_1.createCommentVNode("", true)
                ], 512),
                (_ctx.forwardStatus && _ctx.messageComponents.Forward)
                    ? (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_7, [
                        (vue_1.openBlock(), vue_1.createBlock(vue_1.resolveDynamicComponent('Forward'), {
                            list: _ctx.conversationData.list,
                            message: _ctx.currentMessage,
                            show: _ctx.forwardStatus,
                            isH5: _ctx.env.isH5,
                            "onUpdate:show": _cache[4] || (_cache[4] = function (e) { return (_ctx.forwardStatus = e); })
                        }, {
                            left: vue_1.withCtx(function (_a) {
                                var data = _a.data;
                                return [
                                    vue_1.createElementVNode("img", {
                                        class: "avatar",
                                        src: _ctx.conversationData.handleAvatar(data)
                                    }, null, 8, _hoisted_8),
                                    vue_1.createElementVNode("label", _hoisted_9, vue_1.toDisplayString(_ctx.conversationData.handleName(data)), 1)
                                ];
                            }),
                            right: vue_1.withCtx(function (_a) {
                                var data = _a.data;
                                return [
                                    vue_1.createElementVNode("img", {
                                        class: "avatar",
                                        src: _ctx.conversationData.handleAvatar(data)
                                    }, null, 8, _hoisted_10),
                                    (!_ctx.env.isH5)
                                        ? (vue_1.openBlock(), vue_1.createElementBlock("label", _hoisted_11, vue_1.toDisplayString(_ctx.conversationData.handleName(data)), 1))
                                        : vue_1.createCommentVNode("", true)
                                ];
                            }),
                            _: 1
                        }, 40, ["list", "message", "show", "isH5"]))
                    ]))
                    : vue_1.createCommentVNode("", true),
                vue_1.createElementVNode("div", _hoisted_12, [
                    vue_1.createVNode(_component_ReadReceiptDialog, {
                        message: _ctx.currentMessage,
                        conversation: _ctx.conversation,
                        show: _ctx.receiptDialogStatus,
                        isH5: _ctx.env.isH5,
                        onCloseDialog: _ctx.closeDialog,
                        ref: "readReceiptDialog"
                    }, null, 8, ["message", "conversation", "show", "isH5", "onCloseDialog"])
                ]),
                (_ctx.showImagePreview)
                    ? (vue_1.openBlock(), vue_1.createBlock(_component_imagePreviewer, {
                        key: 1,
                        currentImage: _ctx.currentImagePreview,
                        imageList: _ctx.imageList,
                        onClose: _cache[5] || (_cache[5] = function ($event) { return (_ctx.showImagePreview = false); })
                    }, null, 8, ["currentImage", "imageList"]))
                    : vue_1.createCommentVNode("", true)
            ]),
            vue_1.createElementVNode("div", {
                class: vue_1.normalizeClass(["TUIChat-footer", [_ctx.isMute && 'disabled', _ctx.env.isH5 && 'TUIChat-H5-footer']])
            }, [
                vue_1.createElementVNode("div", _hoisted_13, [
                    vue_1.createElementVNode("main", _hoisted_14, [
                        (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.pluginComponentList, function (item, index) {
                            return (vue_1.openBlock(), vue_1.createBlock(vue_1.resolveDynamicComponent(item), {
                                key: index,
                                isMute: _ctx.isMute,
                                isH5: _ctx.env.isH5,
                                conversation: _ctx.conversation,
                                parentID: "func",
                                onSend: _ctx.handleSend
                            }, null, 40, ["isMute", "isH5", "conversation", "onSend"]));
                        }), 128))
                    ])
                ]),
                vue_1.createVNode(_component_MessageInput, {
                    ref: "messageInput",
                    conversation: _ctx.conversation,
                    memberList: _ctx.allMemberList,
                    env: _ctx.env,
                    isGroup: (_a = _ctx.userInfo) === null || _a === void 0 ? void 0 : _a.isGroup,
                    replyOrReference: _ctx.reference,
                    isMute: _ctx.isMute,
                    muteText: _ctx.muteText,
                    placeholder: _ctx.$t('TUIChat.请输入消息'),
                    onSendMessage: _ctx.reportMessageSend,
                    onResetReplyOrReference: _ctx.resetReplyOrReference,
                    onOnTyping: _ctx.handleTyping
                }, null, 8, ["conversation", "memberList", "env", "isGroup", "replyOrReference", "isMute", "muteText", "placeholder", "onSendMessage", "onResetReplyOrReference", "onOnTyping"])
            ], 2),
            vue_1.withDirectives(vue_1.createElementVNode("div", {
                class: "mask",
                onClick: _cache[8] || (_cache[8] = function ($event) { return (_ctx.showResend = false); })
            }, [
                vue_1.createElementVNode("div", _hoisted_15, [
                    vue_1.createElementVNode("header", null, vue_1.toDisplayString(_ctx.$t("TUIChat.确认重发该消息？")), 1),
                    vue_1.createElementVNode("footer", null, [
                        vue_1.createElementVNode("p", {
                            onClick: _cache[6] || (_cache[6] = function ($event) { return (_ctx.showResend = false); })
                        }, vue_1.toDisplayString(_ctx.$t("TUIChat.取消")), 1),
                        _hoisted_16,
                        vue_1.createElementVNode("p", {
                            onClick: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    return (_ctx.submit && _ctx.submit.apply(_ctx, args));
                                })
                        }, vue_1.toDisplayString(_ctx.$t("TUIChat.确定")), 1)
                    ])
                ])
            ], 512), [
                [vue_1.vShow, _ctx.showResend]
            ])
        ], 2))
        : (_ctx.conversationType === 'system')
            ? (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_17, [
                vue_1.createElementVNode("header", _hoisted_18, [
                    vue_1.createElementVNode("h1", null, vue_1.toDisplayString(_ctx.conversationName), 1)
                ]),
                vue_1.createVNode(_component_MessageSystem, {
                    data: _ctx.messages,
                    types: _ctx.types,
                    onApplication: _ctx.handleApplication
                }, null, 8, ["data", "types", "onApplication"])
            ]))
            : (_ctx.conversationType === 'notice')
                ? (vue_1.openBlock(), vue_1.createElementBlock("iframe", {
                    style: { "width": "100%", "height": "100%", "border": "none" },
                    src: (_c = (_b = _ctx.conversation) === null || _b === void 0 ? void 0 : _b.url) === null || _c === void 0 ? void 0 : _c.replace('www.iguopin.com', 'zhaopin-job.epta.org.cn'),
                    key: _ctx.iframeKey
                }, null, 8, _hoisted_19))
                : (_ctx.slotDefault)
                    ? vue_1.renderSlot(_ctx.$slots, "default", { key: 3 }, undefined, true)
                    : vue_1.createCommentVNode("", true);
}
exports.render = render;
